var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapMutations } from 'vuex';
import { APP_STORE } from '@/stores/defs';
import { forEach, throttle } from 'lodash'; // TODO could be placed in app as global
import EventBus from './eventBus';
var offset = 200;
var pausedForScroll = false;
var waypointMixin = {
    computed: __assign({}, mapGetters({
        waypoints: APP_STORE.GET_WAYPOINTS,
    })),
    methods: __assign({}, mapMutations({
        setWaypoint: APP_STORE.SET_WAYPOINT,
    }), { throttleUpdateAnchor: function (event) {
            var exec = throttle(this.updateNavigationAnchor, 400);
            exec(event);
        },
        updateNavigationAnchor: function (event) {
            if (pausedForScroll) {
                return;
            }
            var route = this.$route;
            var routeName = route.name;
            if (routeName !== 'home') {
                return;
            }
            var scrollTop = event.currentTarget.scrollY;
            var waypoints = this.waypoints;
            var distance = Infinity;
            var currentSection = 'Recent-Orders';
            forEach(this.categories, function (category) {
                var categoryName = category.name;
                if (!waypoints[categoryName]) {
                    return;
                }
                var checkpoint = waypoints[categoryName]() - offset;
                var delta = Math.abs(scrollTop - checkpoint);
                if (distance > delta) {
                    distance = delta;
                    currentSection = categoryName;
                }
            });
            if (scrollTop < offset) {
                currentSection = 'Recent-Orders';
            }
            this.emitScrollEvent(currentSection);
        },
        emitScrollEvent: function (currentSection) {
            EventBus.$emit('scrolledInView', currentSection);
        },
        scrollToSection: function (event, section) {
            var _this = this;
            event.preventDefault();
            var waypoints = this.waypoints;
            var scrollY = waypoints[section]() - offset;
            var scrollElement = "html, body";
            this.$anime.remove(scrollElement);
            pausedForScroll = true;
            this.$anime({
                targets: scrollElement,
                duration: 666,
                scrollTop: scrollY,
                easing: 'easeInOutQuad',
                complete: function () {
                    pausedForScroll = false;
                    _this.emitScrollEvent(section);
                    var element = document.getElementById(section);
                    element.focus();
                }
            });
        } }),
};
export default waypointMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/waypointMixin.ts
// module id = bfiv
// module chunks = 18